<template>
  <div>
    <div class="titleAfter">人格倾向</div>
    <div class="item9">
      <div class="item9-box">
        <div class="box1">抑郁质</div>
        <div class="box2">胆汁质</div>
        <div class="box3">
          <span>粘液质</span>
        </div>
        <div class="box4">
          <span>多血质</span>
        </div>
      </div>
      <span class="instability">不稳定</span>
      <span class="stability">稳定</span>
      <span class="introverted">内向</span>
      <span class="extroversion">外向</span>
      <!-- 问题 -->
      <span class="question">抑郁质：淡漠的 </span>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.titleAfter {
  position: relative;
  color: #6cc6f3;
  padding-left: 10px;
  margin-bottom: 20px;
}
.titleAfter::after {
  content: "";
  position: absolute;
  left: -3px;
  top: 2px;
  width: 3px;
  height: 14px;
  background: #6cc6f3;
  border-radius: 38px 38px 38px 38px;
}
.item9 {
  position: relative;
  .item9-box {
    margin: 85px auto;
    width: 400px;
    height: 400px;
    display: flex;
    flex-wrap: wrap;
    .box1 {
      width: 200px;
      height: 200px;
      background: #2cba83;
      color: #fff;
      box-sizing: border-box;
      padding: 5px;
    }
    .box2 {
      width: 200px;
      height: 200px;
      background: #766efd;
      color: #fff;
      text-align: right;
      box-sizing: border-box;
      padding: 5px;
    }
    .box3 {
      width: 200px;
      height: 200px;
      background: #fdc631;
      color: #fff;
      position: relative;
      span {
        position: absolute;
        bottom: 3px;
        left: 3px;
      }
    }
    .box4 {
      width: 200px;
      height: 200px;
      background: #2ec4f9;
      color: #fff;
      position: relative;
      span {
        position: absolute;
        bottom: 3px;
        right: 3px;
      }
    }
  }
  .instability {
    position: absolute;
    top: -40px;
    left: 345px;
    color: #6cc6f3;
  }
  .stability {
    position: absolute;
    bottom: -40px;
    left: 355px;
    color: #6cc6f3;
  }
  .introverted {
    position: absolute;
    top: 190px;
    left: 105px;
    color: #6cc6f3;
  }
  .extroversion {
    position: absolute;
    top: 190px;
    right: 105px;
    color: #6cc6f3;
  }
  .question {
    color: #fff;
    position: absolute;
    left: 178px;
    top: 60px;
  }
  .question::after {
    content: "";
    position: absolute;
    left: -14px;
    top: 4px;
    width: 10px;
    height: 10px;
    background: #0925E6;
    border-radius: 50%;
  }
}
</style>
